<template>
  <v-container class="" fluid>
    <v-row no-gutters class="">
      <div class=" !w-full !px-5 bg-black h-[calc(100vh-150px)] overflow-scroll  rounded-2xl">
        <div class="" >
          <v-card-title class="justify-center py-6 text-center">
            <h4 :class="`${routeLink}_fortext !text-2xl font-Handel `">Contact Us</h4>
          </v-card-title>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field dark v-model="name" :counter="10" :rules="nameRules" label="Name" persistent-hint required>
            </v-text-field>

            <v-text-field dark v-model="email" :rules="emailRules" label="E-mail" persistent-hint required></v-text-field>

            <v-textarea dark v-model="text" :rules="textRules" label="Text" persistent-hint required></v-textarea>

            <span class="float-right mb-5">
              <v-btn dark :color="colorAsRoute" class="mr-4 mb-4" @click="submit">Submit</v-btn>

            </span>

          </v-form>
        </div>
      </div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ContactUs",
  data: () => ({
    valid: true,
    name: "",
    text: "",
    textRules: [
      (v) => !!v || "Text is required",
      (v) => (v && v.length >= 10) || "Text must be more than 10 characters",
    ],
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
  }),
  methods: {
    submit() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
  },
  computed: {
    colorAsRoute() {
      if (this.routeLink == 'straight') {
        return '#a07a1d'
      }
      else if (this.routeLink == 'gay') {
        return '#88c3fa'
      }
      else if (this.routeLink == 'lesbian') {
        return '#9e2eec'
      }
    }
  },
  created() { },
};
</script>

<style scoped>
.straight_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(335deg,
      rgb(136 97 0) 0%,
      rgb(255 223 153) 53%,
      rgb(130 93 0 / 97%) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gay_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(357deg,
      rgba(0, 240, 255, 1) 55%,
      rgba(0, 156, 255, 1) 75%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.lesbian_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(208deg,
      rgba(126, 0, 157, 0.9416141456582633) 2%,
      rgba(161, 51, 246, 1) 45%,
      rgba(157, 0, 176, 0.9668242296918768) 96%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
